export const separator = "SEPARATOR" as const;
